import * as Yup from 'yup';

export const schema = Yup.object().shape({
  // dataVencimento: Yup.date().nullable().required('Selecione uma data de vencimento'),
  dataFechamento: Yup.date().nullable().required('Selecione uma data de fechamento'),
});
